module.exports = __webpack_public_path__ + "media/images/flags/KW-147d56490be77e0bde11fd02f47f8637.svg";